import { format } from "date-fns";
import { getAccountingBasisLabel } from "@common/helpers/accountingBasis";
import { fullDateFullYearFormat, timeFormat } from "@common/helpers/date";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { useSelectedLedger } from "@hooks/useSelectedLedger";

export function hasChromeText(value: string): boolean {
    return value.trim().length > 0;
}

interface LocalReportChromeParams {
    title: string;
    subtitle: string;
    subtitle2?: string;
    footer: string;
}

/** Chrome for the reports the settings pipeline does not cover yet: elimination ledgers and bank reconciliation. */
export function buildLocalReportChrome({
    title,
    subtitle,
    subtitle2 = "",
    footer,
}: LocalReportChromeParams): ReportPresentationChrome {
    return {
        header: "",
        title,
        subtitle,
        subtitle2,
        footer,
        memo: "",
        watermarkText: "",
    };
}

/** The constants that resolve `generatedDate` / `generatedTime`, so the flag-off footer cannot drift from the server-resolved one. */
const GENERATED_AT_FORMAT = `${fullDateFullYearFormat} ${timeFormat}`;

interface GeneratedFooterTextParams {
    generationDate: Date;
    entityId?: number;
    ledgerId?: string;
}

export function useGeneratedReportFooterText({
    generationDate,
    entityId,
    ledgerId,
}: GeneratedFooterTextParams): string {
    const { selectedLedger } = useSelectedLedger(entityId, ledgerId);
    const basisSegment = selectedLedger
        ? `${getAccountingBasisLabel(selectedLedger.basis)} Basis | `
        : "";
    return `Kick.co | ${basisSegment}${format(generationDate, GENERATED_AT_FORMAT)}`;
}
